import qs from 'qs';
import {
  IPlatformPracticePayload,
  IPlatformPracticeResponse,
  IPlatformPracticesResponse
} from 'types/platformPractice';
import request from './index';

export const getPlatformPractices = (methodologyIds?: number[]) => {
  const query = qs.stringify(
    methodologyIds?.length ? { methodology_ids: methodologyIds } : {},
    { arrayFormat: 'brackets' }
  );

  return request<IPlatformPracticesResponse>({
    options: {
      url: `/platform/resources/practices${query ? `?${query}` : ''}`,
      method: 'get'
    }
  });
};

export const getPlatformPractice = (id: number) =>
  request<IPlatformPracticeResponse>({
    options: {
      url: `/platform/resources/practices/${id}`,
      method: 'get'
    }
  });

export const createPlatformPractice = (data: IPlatformPracticePayload) =>
  request<IPlatformPracticeResponse>({
    options: {
      url: '/platform/resources/practices',
      method: 'post',
      data
    }
  });

export const editPlatformPractice = (id: number, data: IPlatformPracticePayload) =>
  request<IPlatformPracticeResponse>({
    options: {
      url: `/platform/resources/practices/${id}`,
      method: 'patch',
      data
    }
  });

export const deletePlatformPractice = (id: number) =>
  request<Record<string, never>>({
    options: {
      url: `/platform/resources/practices/${id}`,
      method: 'delete'
    }
  });
